import $ from "jQuery";
import { debounce } from "./utils/functions";

const dms = (element) => {
  bindToggleDms(element);
  bindFilter(element);
};

const bindFilter = (element) => {
  element.off("input", "input[name='folder-filter-search']");
  element.on(
    "input",
    "input[name='folder-filter-search']",
    debounce(function () {
      const keyWord = String($(this).val()).replace(/\s/g, "").toLowerCase();

      if (keyWord) {
        const $items = element.find(".dms__title");
        const $dmsToggles = element.find(".dms-toggle");
        const matchingKeyWords = [];

        $items.each(function () {
          const kw = $(this).html().replace(/\s/g, "").toLowerCase();
          if (kw.includes(keyWord)) {
            matchingKeyWords.push(kw);
          }
        });

        $items.closest(".dms__item").attr("data-hidden", "true").hide();
        $dmsToggles.attr("data-hidden", "false").show();

        if (matchingKeyWords.length) {
          const process = matchingKeyWords.reduce((promiseChain, kw) => {
            return promiseChain.then(
              () =>
                new Promise((resolve) => {
                  const $matchingElements = element
                    .find(".dms__title")
                    .filter(function () {
                      return (
                        $(this).html().replace(/\s/g, "").toLowerCase() == kw
                      );
                    })
                    .closest(".dms__item")
                    .attr("data-hidden", "false");

                  const $matchingElementsNotInTree = $matchingElements.filter(
                    function () {
                      return $(this).closest(".dms-toggle").length == 0;
                    }
                  );

                  if ($matchingElementsNotInTree.length) {
                    $matchingElementsNotInTree.show();
                  }
                  resolve();
                })
            );
          }, Promise.resolve());

          process.then(() => {
            element
              .find(".dms__item")
              .filter(function () {
                const $thisEl = $(this);
                return (
                  $thisEl.attr("data-hidden") === "false" &&
                  !$thisEl.hasClass("dms-toggle")
                );
              })
              .parents(".dms-toggle")
              .trigger("click", ["show"]);

            $dmsToggles
              .filter(function () {
                const $visibleItems = $(this)
                  .find(".dms__item")
                  .filter(function () {
                    const $thisEl = $(this);
                    return (
                      $thisEl.attr("data-hidden") === "false" &&
                      !$thisEl.hasClass("dms-toggle")
                    );
                  });
                return $visibleItems.length == 0;
              })
              .attr("data-hidden", "true")
              .hide();
          });
        } else {
          $dmsToggles.attr("data-hidden", "true").hide();
        }
      } else {
        element
          .find(".dms__title")
          .closest(".dms__item")
          .attr("data-hidden", "false")
          .filter(function () {
            return (
              $(this)
                .closest(".dms-toggle")
                .filter(function () {
                  return !$(this).hasClass("active");
                }).length == 0
            );
          })
          .show();
        element
          .find(".dms-toggle")
          .attr("data-hidden", "false")
          .show()
          .trigger("click", ["hide"]);
      }
    })
  );
  element.off("click", "button[name='remove-folder-filter']");
  element.on("click", "button[name='remove-folder-filter']", () =>
    element.find('input[name="folder-filter-search"]').val("").trigger("input")
  );
};

const bindToggleDms = (element) => {
  const $dmsToggle = element.find(".dms-toggle");

  $dmsToggle.off("click");
  $dmsToggle.on("click", toggleDms);
};

function toggleDms(e, mode = "toggle") {
  e.stopPropagation();

  const $thisEl = $(this);

  const level = $thisEl.data("level");
  const $icon = $thisEl.find(".dms__icon-folder:first");
  const $subelement = $thisEl
    .children(".dms__level" + (parseInt(level) + 1))
    .filter(function () {
      return $(this).attr("data-hidden") === "false";
    });

  const showDms = () => {
    $thisEl.addClass("active");
    $icon.addClass("active");
    $subelement.show();
  };
  const hideDms = () => {
    $thisEl.removeClass("active");
    $icon.removeClass("active");
    $subelement.hide();
  };

  if ($subelement.length) {
    switch (mode) {
      case "toggle":
        $subelement.is(":hidden") ? showDms() : hideDms();
        break;
      case "show":
        showDms();
        break;
      case "hide":
        hideDms();
        break;
    }
  }
}

export const reloadScriptDms = () => {
  const $dmsEl = $(".dms");

  $dmsEl.each(function () {
    dms($(this));
  });
};
reloadScriptDms();
